export const getSortedList = (unsortedItems: string | Array<any>, maxItems: number) => {
  const maxSortedItems = maxItems ?? (unsortedItems?.length || 0);
  const sortedItems = [...unsortedItems]
    ?.sort((a, b) => {
      if (a.priority !== undefined && b.priority === undefined) {
        return -1;
      }
      if (a.priority === undefined && b.priority !== undefined) {
        return 1;
      }
      if (a.priority !== b.priority) {
        return (a.priority ?? 0) - (b.priority ?? 0);
      }
      return new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime();
    })
    ?.slice(0, Math.min(maxSortedItems, unsortedItems.length));
  return sortedItems;
};
